import { startCase, toLower } from "lodash";

export function formatClassificationValue(classification: string) {
  return startCase(toLower(classification.split("_").join(" ")));
}
